module.exports = __webpack_public_path__ + "files/9c69aa60cf3a3c3b8bacfe703a840401.png";